import { type MouseEventHandler } from 'react';
import { CloseModalButton, CloseVideoModalButton } from './CloseButton.styles';
import CloseIcon from '@/components/Icon/components/CloseIcon/CloseIcon';

const CloseButton = ({
  handleClick,
  isVideoModal,
}: {
  handleClick: MouseEventHandler<HTMLButtonElement>;
  isVideoModal: boolean;
}) => {
  // NOTE This check and return statement can be removed when a dedicated video modal is implemented (added in the roadmap backlog)
  if (isVideoModal) {
    return (
      <CloseVideoModalButton onClick={handleClick} aria-label="Close video modal">
        <CloseIcon variant="close_icon" />
      </CloseVideoModalButton>
    );
  }

  return (
    <CloseModalButton onClick={handleClick} aria-label="Close modal">
      <CloseIcon variant="close_icon_basic_light" />
    </CloseModalButton>
  );
};

export default CloseButton;
